import axios from 'axios';
import { isJwtExpiredByDailyMidnight } from './jwtDailyExpiry';

const TUTORIAL_TOKEN_KEY = 'ipe_tutorial_token';

const tutorialApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
});

tutorialApi.interceptors.request.use((config) => {
  const token = peekTutorialToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

tutorialApi.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const body = error.response?.data;
    const msg = body?.message || body?.error || error.message || '请求失败';
    return Promise.reject(new Error(msg));
  },
);

export function peekTutorialToken() {
  const token = localStorage.getItem(TUTORIAL_TOKEN_KEY);
  return token && String(token).trim() ? String(token).trim() : null;
}

export function getTutorialToken() {
  const trimmed = peekTutorialToken();
  if (!trimmed) return null;
  if (isJwtExpiredByDailyMidnight(trimmed)) {
    setTutorialToken(null);
    return null;
  }
  return trimmed;
}

export function setTutorialToken(token) {
  if (token) {
    localStorage.setItem(TUTORIAL_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TUTORIAL_TOKEN_KEY);
  }
}

export const tutorialAPI = {
  login: (username, password) => tutorialApi.post('/tutorial/auth/login', { username, password }),
  register: (username, password) =>
    tutorialApi.post('/tutorial/auth/register', { username, password }),
  applyEditor: (reason) => tutorialApi.post('/tutorial/auth/apply-editor', { reason: reason || '' }),
  getMe: () => tutorialApi.get('/tutorial/auth/me'),
  updateProfile: (payload) => tutorialApi.patch('/tutorial/auth/profile', payload),
  uploadAvatar: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const data = await tutorialApi.post('/tutorial/auth/upload-avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data?.url || '';
  },
  getTree: () => tutorialApi.get('/tutorial/tree'),
  getNode: (slug) => tutorialApi.get(`/tutorial/nodes/${encodeURIComponent(slug)}`),
  getByNavId: (navId) => tutorialApi.get(`/tutorial/nav/${encodeURIComponent(navId)}`),
  search: (q) => tutorialApi.get('/tutorial/search', { params: { q } }),
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const data = await tutorialApi.post('/tutorial/editor/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data?.url || '';
  },
  createNode: (payload) => tutorialApi.post('/tutorial/editor/nodes', payload),
  updateNode: (id, payload) => tutorialApi.put(`/tutorial/editor/nodes/${id}`, payload),
  deleteNode: (id) => tutorialApi.delete(`/tutorial/editor/nodes/${id}`),
};
